module.exports = __webpack_public_path__ + "static/img/brees-2015-slide-4.4e9ee01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2015-slide-4.jpg
// module id = E7P+
// module chunks = 1